<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :loading="isFetch"
            loading-text="Загрузка данных... Ожидайте"
            :footer-props="{itemsPerPageOptions: [5, 10, 15]}"
    >
        <template v-slot:item.actions="{ item }">
            <v-btn
                v-if="item.status_raw === 'ACTIVE'"
                :disabled="isFetch"
                depressed
                color="error"
                @click="onClose(item.id)"
            >
                закрыть
            </v-btn>
        </template>
    </v-data-table>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>
<script>
import * as api from '@/api/workspace';
import {mapActions, mapGetters} from 'vuex';
export default {
    name: 'WorkSpaceInviteList',
    props:{
        workSpaceId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isFetch: false,
            options: {
                perPage: 10,
                page: 1
            },
            total: 0,
            itemsData: [],
        }
    },
    watch: {
        options: {
            handler () {
                this.load();
            },
            deep: true,
        },
        workSpaceId: function () {
            this.options.page = 1;
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        ...mapGetters('workspace', ['ID_WORK_SPACE']),
        async load(){
            this.isFetch = true;
            const { page, itemsPerPage } = this.options
            try{
                let { data } = await api.invites(this.workSpaceId, {page, perPage: itemsPerPage});
                this.total = data.meta.total
                this.itemsData.splice(0, this.itemsData.length, ...data.data);
            }catch (e) {
                this.SHOW_ERROR('Ошибка загрузки данных');
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        },
        async onClose(inviteId){
            this.isFetch = true;
            try{
                let { data } = await api.inviteClose(this.workSpaceId, inviteId);
                this.SHOW_SUCCESS(data.message);
            }catch (e) {
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Ошибка закрытия'});
                console.log(e);
            }finally {
                this.isFetch = false;
                this.load();
            }
        }
    },
    computed:{
        headers(){
            return [
                { text: 'Инициатор', value: 'initiator_name' },
                { text: 'Статус', value: 'status' },
                { text: 'email', value: 'invite_email' },
                { text: 'Создано', value: 'created_at' },
                { text: 'Действительно до', value: 'active_at' },
                { text: 'Действия', value: 'actions' }
            ];
        },
        items(){
            return this.itemsData;
        }
    }
}
</script>